export const CODE_ESCAPE = 'Escape';

export const SERVICES_HAS_SMS_SUBSCRIPTIONS = {
    '10100': true, // MapleStory
    '50203': true, // KartRider
};

export const COOKIES_PARTNER_KEY = 'PARTNERKEY';
